export default __webpack_public_path__ + "static/media/poster2.ecde644c.jpg";